module.exports = __webpack_public_path__ + "static/media/retrato_6.c55d3367.jpg";